import "./UwCommRates.scss";
import CircularButton, { CustomLoadingButton } from "../../../components/ui/CustomButton";
import newRequest from "../../../utils/newRequest";
import SendIcon from '@mui/icons-material/Send';
import CloseIcon from "@mui/icons-material/Close";
import { FaSave } from "react-icons/fa";
import { FiSearch } from "react-icons/fi";
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
  Typography,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent
} from "@mui/material";
import { showToast } from "../../../toastService.js";
import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { GridLoader } from "react-spinners";
import { SlArrowDown } from "react-icons/sl";
import { formatAmountsToDecimals, formatStringToNumberV2 } from "../../../utils/genericFunctions";
import { customSelectStyles_dark, customSelectStyles_light } from "../../../components/ui/CustomSelect.jsx";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { MdAdd, MdArrowBackIos } from "react-icons/md";


const UwCommRates = () => {
  const { t } = useTranslation();
  const { currentUser } = useSelector((state) => state.user);
  const { currentTheme } = useSelector((state) => state.theme);
  const location = useLocation();
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const showBack = location.state?.showBack || "N";
  const [searchTermEntities, setSearchTermEntities] = useState("");
  const [entitiesPage, setEntitiesPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [commissionRates, setCommissionRates] = useState([]);
  const [selectedEntityCatg, setSelectedEntityCatg] = useState({});
  const [entityCatgOptions, setEntityCatgOptions] = useState([]);

  const fetchEntityCatg = async () => {
    try {
      const res = await newRequest.get("/allEntityCatg/findAll");

      const options = res.data.map((entityCatg) => ({
        value: entityCatg?.aent_code,
        label: entityCatg?.aent_name,
      }));

      setEntityCatgOptions(options);

      if (["broker", "agent"].includes(currentUser?.token_org_type)) {
        setSelectedEntityCatg({
          value: "Insurance Company",
          label: "Insurance Company",
        })
      }

    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };

  const [selectedSubClassCover, setSelectedSubClassCover] = useState(null);
  const [subClassCovers, setSubClassCovers] = useState([]);
  const fetchSubClassCovers = async () => {
    try {
      const res = await newRequest.post(
        "/uwSubClassCover/findAll",
        {
          cc_mc_code: "",
          cc_sc_code: "",
        }
      );

      const options = res.data.map((cover) => ({
        mc_code: cover?.cc_mc_code,
        sc_code: cover?.cc_sc_code,
        cc_code: cover?.cc_code,
        cc_desc: cover?.cc_desc,
        value: cover?.cc_code,
        label: `[MC ${cover?.cc_mc_code}, SC ${cover?.cc_sc_code}, CC ${cover?.cc_code}] ${cover?.cc_name}`,
      }));
      setSubClassCovers(options);
    } catch (error) {
      console.error("Error fetching product covers :", error);
    }
  };


  useEffect(() => {
    fetchEntityCatg();
    fetchSubClassCovers();
  }, []);

  const fetchCommissionRates = async () => {
    try {
      setIsProcessing(true);
      const res = await newRequest.post("/uwPolicy/commRates", { ent_aent_code: selectedEntityCatg?.value });
      setCommissionRates(res.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsProcessing(false);
    }
  };


  const handleEntitiesChangePage = (event, newPage) => {
    setEntitiesPage(newPage);
  };

  const handleEntitiesChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setEntitiesPage(0);
  };



  const filteredEntitiesData = commissionRates?.filter(
    (item) =>
      item.ent_name?.toLowerCase().includes(searchTermEntities.toLowerCase()) ||
      item.ent_id_no?.toLowerCase().includes(searchTermEntities.toLowerCase()) ||
      item.ent_tax_no?.toLowerCase().includes(searchTermEntities.toLowerCase()) ||
      item.ent_phone_no?.toLowerCase().includes(searchTermEntities.toLowerCase()) ||
      item.ent_email?.toLowerCase().includes(searchTermEntities.toLowerCase())
  );

  const slicedEntitiesData = filteredEntitiesData?.slice(
    entitiesPage * rowsPerPage,
    entitiesPage * rowsPerPage + rowsPerPage
  );
  // commission rates table
  const [searchTermRates, setSearchTermRates] = useState("");
  const [ratesPage, setRatesPage] = useState(0);
  const [rowsPerPageRates, setRowsPerPageRates] = useState(10);
  const [entityCommissionRates, setEntityCommissionRates] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [selectedRatesRow, setSelectedRatesRow] = useState(null);
  const [selectedEntity, setSelectedEntity] = useState(null);

  const handleAccodionChange = (panel, entity) => (event, isExpanded) => {
    try {
      setExpanded(isExpanded ? panel : false);
      setSelectedEntity(isExpanded ? entity : null);
      const formattedRates = entity.comm_rates?.map(rate => ({
        ...rate,
        cr_comm_rate: formatAmountsToDecimals(rate?.cr_comm_rate, 6) || 0,
        cr_comm_tax_rate: formatAmountsToDecimals(rate?.cr_comm_tax_rate, 6) || 0,
        cr_prem_rate: formatAmountsToDecimals(rate?.cr_prem_rate, 6) || 0,
      }));
      setEntityCommissionRates(formattedRates);
    } catch (error) {
      console.log(error)
    }
  };

  const handleRatesChangePage = (event, newPage) => {
    setRatesPage(newPage);
  };

  const handleRatesChangeRowsPerPage = (event) => {
    setRowsPerPageRates(parseInt(event.target.value, 8));
    setRatesPage(0);
  };


  const filteredRatesData = entityCommissionRates?.filter(
    (item) =>
      item.cc_code?.toLowerCase().includes(searchTermRates?.toLowerCase()) ||
      item.cc_name?.toLowerCase().includes(searchTermRates?.toLowerCase()) ||
      item.class_name_xx?.toLowerCase().includes(searchTermRates?.toLowerCase()) ||
      item.sub_class_name_xx?.toLowerCase().includes(searchTermRates?.toLowerCase())
  );

  const slicedRatesData = filteredRatesData.slice(
    ratesPage * rowsPerPage,
    ratesPage * rowsPerPage + rowsPerPage
  );

  const handleRatesChange = (e, rowId) => {
    try {
      const { name, value } = e.target;
      const updatedData = [...entityCommissionRates];
      const rowIndex = updatedData.findIndex(item => item._id === rowId);

      if (rowIndex === -1) {
        throw new Error('row not found');
      }
      updatedData[rowIndex][name] = value;
      updatedData[rowIndex]["changed_xx"] = "Y";

      setEntityCommissionRates(updatedData);
    } catch (error) {
      console.log(error);
    }
  };

  const formatNumber = (value, decimals = 2) => {
    try {
      if (isNaN(formatStringToNumberV2(value))) return value;
      return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: decimals
      }).format(value);
    } catch (error) {
      console.log(error)
    }
  };


  const handleRatesBlur = (rowId, field) => {
    try {
      const updatedData = [...entityCommissionRates];
      const rowIndex = updatedData.findIndex(item => item._id === rowId);

      if (rowIndex === -1) {
        throw new Error('row not found');
      }
      let value = updatedData[rowIndex][field];
      value = formatNumber(formatStringToNumberV2(value), 6);
      updatedData[rowIndex][field] = value;
      setEntityCommissionRates(updatedData);
    } catch (error) {
      console.log(error);
    }
  };

  const saveRecord = async () => {
    try {
      const changedRates = entityCommissionRates?.filter(
        (obj) => obj.changed_xx === "Y"
      );
      for (let i = 0; i < changedRates.length; i++) {
        await newRequest.post("/uwCoverCommRate/inject", {
          cr_mc_code: changedRates[i]?.cc_mc_code,
          cr_sc_code: changedRates[i]?.cc_sc_code,
          cr_cc_code: changedRates[i]?.cc_code,
          cr_ent_code: selectedEntity?.ent_code,
          cr_aent_code: selectedEntity?.ent_aent_code,
          cr_comm_rate: parseFloat(formatStringToNumberV2(changedRates[i]?.cr_comm_rate || 0, 6)) || 0,
          cr_comm_tax_rate: parseFloat(formatStringToNumberV2(changedRates[i]?.cr_comm_tax_rate || 0, 6)) || 0,
          cr_prem_rate: parseFloat(formatStringToNumberV2(changedRates[i]?.cr_prem_rate || 0, 6)) || 0
        });
      }
      showToast("Saved!", "success");
    } catch (error) {
      console.log(error)
    }
  };

  return (
    <motion.div
      className="comm-rates"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}
      exit={{ opacity: 0, transition: { duration: 1 } }}
    >
      <div className="comm-rates-navbar">
        <div className="comm-rates-navbar-left">
          <div className="search-input-wrapper" style={{ width: "30%" }}>
            <FiSearch className="search-input-icon" />
            <input
              className="search-input"
              type="text"
              placeholder="Search..."
              value={searchTermEntities}
              onChange={(e) => setSearchTermEntities(e.target.value)}
            />
            {searchTermEntities.length > 0 && (
              <CloseIcon
                onClick={() => setSearchTermEntities("")}
                className="search-input-icon"
              />
            )}
          </div>
          <Select
            id="ent_catg"
            name="ent_catg"
            styles={{
              ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
              menuPortal: base => ({
                ...base,
                zIndex: 9999,
              })
            }}
            height="40px"
            width="300px"
            value={selectedEntityCatg}
            onChange={(selectedOption) => setSelectedEntityCatg(selectedOption)}
            options={entityCatgOptions}
            isSearchable={true}
            placeholder="Category"
          />
          <CustomLoadingButton
            currentTheme={currentTheme}
            iconPosition="end"
            endIcon={<SendIcon />}
            onClick={fetchCommissionRates}
          >
            {t('search')}
          </CustomLoadingButton>
        </div>
        <div className="comm-rates-navbar-right">
          <span className="sub-title boldsmall">If you change any rate, ensure you click SAVE</span>
          {/* This part shows if the menu was opened from home screen */}
          {showBack === "Y" && <hr className="separator-v" />}
          {showBack === "Y" &&
            <span className="back-icon" onClick={() => navigate(-1)}>
              <MdArrowBackIos size={24} />
            </span>
          }
        </div>
      </div>
      <div className="comm-rates-content">
        {slicedEntitiesData?.length > 0 &&
          <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }}
            className="table-container">
            <Table sx={{ width: "max-content", border: 'none' }}>
              <TableBody className="tablebody-accordion">
                {slicedEntitiesData?.map((entity, index) => (
                  <TableRow
                    key={entity._id}
                    className="tablerow-accordion">
                    <TableCell className="table-cell-accordion"
                      style={{
                        display: "flex",
                        width: "100%",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: "bold",
                      }}>
                      <Accordion className="accordion" expanded={expanded === entity._id} onChange={handleAccodionChange(entity._id, entity)}>
                        <AccordionSummary
                          className="accordion-summary"
                          expandIcon={<SlArrowDown className="content-accordion-expand-icon" style={{ color: "#f44336", fontWeight: "bold" }} />}
                          id={`panel-${entity._id}-header`}
                        >
                          <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", width: "100%", marginRight: "50px" }}>
                            <Typography>
                              <span className="sr-no">{entitiesPage * rowsPerPage + index + 1}.</span> <span>{entity.ent_name}</span>
                            </Typography>
                            <Typography>
                              <span className="ngen-details">
                                <span className="account-no">{`Account No : ${entity.ent_code}`}</span>
                                <span className={`status ${entity.ent_status}`}>
                                  {entity.ent_status}
                                </span>
                              </span>
                            </Typography>
                          </div>
                        </AccordionSummary>
                        <AccordionDetails className="accordion-details">
                          <div className="search">
                            <div className="comm-rates-navbar">
                              <div className="comm-rates-navbar-left">
                                <div className="search-input-wrapper" style={{ width: "100%" }}>
                                  <FiSearch className="search-input-icon" />
                                  <input
                                    className="search-input"
                                    type="text"
                                    placeholder={t('search')}
                                    value={searchTermRates}
                                    onChange={(e) => setSearchTermRates(e.target.value)}
                                  />
                                  {searchTermRates.length > 0 && (
                                    <CloseIcon
                                      onClick={() => setSearchTermRates("")}
                                      className="search-input-icon"
                                    />
                                  )}
                                </div>
                              </div>
                              <div className="comm-rates-navbar-right">
                                <Select
                                  id="cover"
                                  name="cover"
                                  menuPortalTarget={document.body}
                                  styles={{
                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                    menuPortal: base => ({
                                      ...base,
                                      zIndex: 9999,
                                    })
                                  }}
                                  width="315px"
                                  value={selectedSubClassCover}
                                  onChange={(selectedOption) => setSelectedSubClassCover(selectedOption)}
                                  options={subClassCovers}
                                  isSearchable={true}
                                  placeholder={t('cover').toUpperCase()}
                                />
                                <CircularButton
                                  currentTheme={currentTheme}
                                  onClick={async () => {
                                    try {

                                      if (!selectedSubClassCover) {
                                        setNotifyDialogTitle("Note!");
                                        setNotifyDialogText(`Please select cover`);
                                        setIsNotifyDialogOpen(true);
                                        return;
                                      }

                                      const res = await newRequest.post("/uwCoverCommRate/inject", {
                                        cr_mc_code: selectedSubClassCover?.mc_code,
                                        cr_sc_code: selectedSubClassCover?.sc_code,
                                        cr_cc_code: selectedSubClassCover?.cc_code,
                                        cr_ent_code: entity.ent_code,
                                        cr_aent_code: entity?.ent_aent_code,
                                        cr_comm_rate: 0,
                                        cr_comm_tax_rate: 0,
                                        cr_prem_rate: 0
                                      });

                                      if (res.data.status === "success") {
                                        setEntityCommissionRates((prev) => [...prev, res.data.doc]);
                                        setSelectedSubClassCover(null);
                                        showToast(`Added`, "success");
                                      } else {
                                        showToast(`Unable to add record`, "error");
                                      }
                                    } catch (error) {
                                      console.log(error);
                                    }
                                  }}
                                  icon={<MdAdd />} width={"35px"} height={"35px"} />
                                <hr className="separator-v" />
                                <CustomLoadingButton
                                  currentTheme={currentTheme}
                                  iconPosition="end"
                                  endIcon={<FaSave />}
                                  onClick={saveRecord}>
                                  {t('save')}
                                </CustomLoadingButton>
                              </div>
                            </div>
                          </div>
                          <div className="table-content">
                            <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                              <Table sx={{ width: "max-content", border: 'none' }}>
                                <TableHead className="tablehead">
                                  <TableRow className="tablerow">
                                    <TableCell className="table-cell" style={{ display: "flex", maxWidth: "50px", justifyContent: "center" }}>
                                      <span>#</span>
                                    </TableCell>
                                    <TableCell className="table-cell" style={{ maxWidth: "300px" }}>
                                      <span>CLASS & SUB CLASS</span>
                                    </TableCell>
                                    <TableCell className="table-cell" style={{ width: "auto", display: 'flex', }}>
                                      <span>COVER</span>
                                    </TableCell>
                                    <TableCell className="table-cell" style={{ alignItems: "center", maxWidth: "150px", display: 'flex', justifyContent: 'flex-end' }}>
                                      <span style={{ alignSelf: "flex-end" }}>COMMISSION [%]</span>
                                    </TableCell>
                                    <TableCell className="table-cell" style={{ alignItems: "center", maxWidth: "150px", display: 'flex', justifyContent: 'flex-end' }}>
                                      <span style={{ alignSelf: "flex-end" }}>COMM TAX [%]</span>
                                    </TableCell>
                                    <TableCell className="table-cell" style={{ alignItems: "center", maxWidth: "150px", display: 'flex', justifyContent: 'flex-end' }}>
                                      <span style={{ alignSelf: "flex-end" }}>PREMIUM [%]</span>
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody className="tablebody">
                                  {slicedRatesData?.map((row, index) => (
                                    <TableRow
                                      key={row?._id}
                                      className={`${selectedRatesRow?._id === row?._id ? "tablerow current" : "tablerow"}`}
                                      onClick={() => setSelectedRatesRow(row)}
                                    >
                                      <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                        <span>{ratesPage * rowsPerPageRates + index + 1}</span>
                                      </TableCell>
                                      <TableCell className="table-cell" style={{ maxWidth: "250px" }}>
                                        <h1 className="sub-title">{`${row?.class_name_xx} - [${row?.cc_mc_code}]`}</h1>
                                        <h1 className="sub-title">{`${row?.sub_class_name_xx} - [${row?.cc_sc_code}]`}</h1>
                                      </TableCell>
                                      <TableCell className="table-cell" style={{ width: "auto" }}>
                                        <h1 className="sub-title">{`${row?.cc_name} - [${row?.cc_code}]`}</h1>
                                      </TableCell>
                                      <TableCell className="table-cell right" style={{ maxWidth: "150px" }}>
                                        <div className="input-item-with-label">
                                          <input
                                            id="cr_comm_rate"
                                            name="cr_comm_rate"
                                            type="text"
                                            value={row?.cr_comm_rate}
                                            onChange={(e) => handleRatesChange(e, row?._id)}
                                            style={{ width: "100%", textAlign: "right" }}
                                            className="form-input-item table"
                                            onBlur={() => { handleRatesBlur(row?._id, "cr_comm_rate"); }}
                                            disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                                          />
                                        </div>
                                      </TableCell>
                                      <TableCell className="table-cell right" style={{ maxWidth: "150px" }}>
                                        <div className="input-item-with-label">
                                          <input
                                            id="cr_comm_tax_rate"
                                            name="cr_comm_tax_rate"
                                            type="text"
                                            value={row?.cr_comm_tax_rate}
                                            onChange={(e) => handleRatesChange(e, row?._id)}
                                            style={{ width: "100%", textAlign: "right" }}
                                            className="form-input-item table"
                                            onBlur={() => { handleRatesBlur(row?._id, "cr_comm_tax_rate"); }}
                                            disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                                          />
                                        </div>
                                      </TableCell>
                                      <TableCell className="table-cell right" style={{ maxWidth: "150px" }}>
                                        <div className="input-item-with-label">
                                          <input
                                            id="cr_prem_rate"
                                            name="cr_prem_rate"
                                            type="text"
                                            value={row?.cr_prem_rate}
                                            style={{ width: "100%", textAlign: "right" }}
                                            className="form-input-item table"
                                            onChange={(e) => handleRatesChange(e, row?._id)}
                                            onBlur={() => { handleRatesBlur(row?._id, "cr_prem_rate"); }}
                                            disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                                          />
                                        </div>
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                              <TablePagination
                                rowsPerPageOptions={[10]}
                                rowsPerPage={rowsPerPageRates}
                                onRowsPerPageChange={handleRatesChangeRowsPerPage}
                                component="div"
                                count={filteredRatesData.length}
                                page={ratesPage}
                                onPageChange={handleRatesChangePage}
                              />
                            </TableContainer>
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[10]}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleEntitiesChangeRowsPerPage}
              component="div"
              count={filteredEntitiesData.length}
              page={entitiesPage}
              onPageChange={handleEntitiesChangePage}
            />
          </TableContainer>
        }
      </div>
      {
        isProcessing && (
          <motion.div
            className="processing-dialog"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 1 } }}
            exit={{ opacity: 0, transition: { duration: 1 } }}
          >
            <div className="processing-wrapper">
              <GridLoader
                color="#bd97fc"
                style={{
                  height: "50px",
                  width: "50px",
                }}
              />
            </div>
          </motion.div>
        )
      }

      {/* Dialog to notify user about changes being saved */}
      <Dialog open={isNotifyDialogOpen}
        onClose={() => setIsNotifyDialogOpen(false)}
       PaperProps={{
          sx: {
            borderRadius: "16px",
            backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
            color: currentTheme === "dark" ? "#fff" : "#000",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          },
        }}>
        <DialogTitle>{notifyDialogTitle}</DialogTitle>
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
        </DialogContent>
        <DialogActions>
          <CustomLoadingButton currentTheme={currentTheme} variant="tint" color="#E040FB" onClick={() => setIsNotifyDialogOpen(false)}>{t('close')}</CustomLoadingButton>
        </DialogActions>
      </Dialog>
    </motion.div>
  );
};

export default UwCommRates;
